import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'StartScene',
    });
  }

  preload() {}

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();
    this.anims.create({
      key: 'walk',
      frames: this.anims.generateFrameNames('characterWalkAnim', {
        start: 0,
        end: 211,
        prefix: 'walkLift',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.erfloorAudio = this.sound.add('erfloor').setVolume(0.05);
    this.edopenAudio = this.sound.add('edopen').setVolume(0.05);

    this.bg0 = this.add.image(0, 0, 'bg').setOrigin(0);
    this.liftDoor = this.add
      .image(1030, 368, 'liftDoor')
      .setCrop(90, 30, 404 - 180, 460)
      .setScale(0, 1);
    this.doorMask = this.add.image(852, 149.5, 'doorMask').setOrigin(0);

    this.liftOpen = this.add.sprite(0, 0);

    this.bg = this.add.image(0, 0, 'Background').setOrigin(0);
    this.cloud1 = this.add.sprite(-180, 20, 'cloud1').setOrigin(0);

    this.cloud2 = this.add.image(1280, 18, 'cloud2').setOrigin(0);

    this.cloud3 = this.add.image(1280 + 200, 18, 'cloud3').setOrigin(0);

    this.build = this.add
      .image(539, 41, 'build')
      .setScale(1.001)
      .setOrigin(0)
      .setCrop(0, 0, 203, 330.5);
    this.glare = this.add.image(539, -230, 'glare').setOrigin(0);

    this.door = this.add.image(589, 330, 'door').setOrigin(0);
    this.shadow = this.add.image(-200, 630, 'shadow').setOrigin(0).setVisible(false); //550
    this.arrow = this.add.image(757, 324, 'arrows').setOrigin(0).setVisible(false);
    this.character = this.add
      .sprite(0, 0, 'characterWalkAnim')
      .setOrigin(0)
      .setVisible(false);

    this.tweens.add({
      targets: [this.glare],
      y: 360,
      ease: 'Linear',
      duration: 7000,
      repeat: -1,
    });

    this.tweens.add({
      targets: [this.cloud1],
      x: 1400,
      ease: 'linear',
      duration: 60000,
      repeat: -1,
    });

    this.tweens.add({
      targets: [this.cloud2],
      x: -200,
      ease: 'linear',
      delay: 0,
      duration: 60000,
      repeat: -1,
    });

    this.tweens.add({
      targets: [this.cloud3],
      x: -200,
      ease: 'linear',
      duration: 60000,
      delay: 1000,
      repeat: -1,
    });
    this.playButton = this.add
      .image(525, 345, 'play_button')
      .setInteractive({ cursor: 'pointer' })
      .setOrigin(0, 0);

    this.GameName = this.add.image(640, 250, 'GameName').setOrigin(0.5, 0);
    this.playButton.on(
      'pointerover',
      function () {
        this.playButton.setTexture('play_button_on');
      },
      this,
    );

    this.playButton.on(
      'pointerout',
      function () {
        this.playButton.setTexture('play_button');
      },
      this,
    );

    this.playButton.on(
      'pointerdown',
      function () {
        enablePointerEvents();
        this.scene.launch('GameScene');
        this.scene.launch('HintScene');
        // this.scene.launch("EndScene");
        this.GameName.setScale(0);
        this.playButton.setScale(0);

        this.time.delayedCall(
          500,
          () => {
            this.tweens.add({
              targets: [
                this.glare,
                this.bg,
                this.door,
                this.cloud1,
                this.cloud2,
                this.cloud3,
                this.build,
              ],
              alpha: 0,
              ease: 'Linear',
              duration: 500,
              repeat: 0,
              onComplete: () => {
                this.character.play('walk').setVisible(true);

                this.shadow.setVisible(true);
                this.tweens.add({
                  targets: this.shadow,
                  x: 550,
                  ease: 'power2.easeInOut', //"sine.easeInOut",
                  duration: 3250,
                  repeat: 0,
                });
              },
            });
          },
          [],
          this,
        );

        this.time.delayedCall(
          5600,
          () => {
            this.erfloorAudio.play();

            this.zero = this.add.image(1023, 109, '0s').setOrigin(0);
            this.arrow.setVisible(true);

            this.tweens.add({
              targets: this.liftOpen,
              x: 1.41,
              ease: 'Linear',
              delay: 1000,
              duration: 2300,
              repeat: 0,
              onStart: () => {
                this.edopenAudio.play();
              },

              onComplete: () => {
                this.tweens.add({
                  targets: [
                    this.shadow,
                    this.liftOpen,
                    this.arrow,
                    this.zero,
                    this.bg0,
                    this.liftDoor,
                    this.doorMask,
                    this.liftOpen,
                    this.character,
                  ],
                  alpha: 0,
                  ease: 'Linear',
                  delay: 500,
                  duration: 500,
                  repeat: 0,
                  onComplete: () => {},
                });
              },
            });
          },
          [],
          this,
        );
      },
      this,
    );
  }

  startloads() {}

  update() {
    // if (gameState.gameWin) {
    //   //  this.boy.setAlpha(0);
    //   this.plugins.get("rexkawaseblurpipelineplugin").add(this.boy, config);

    //   gameState.gameWin = false;
    // }

    this.liftDoor.setScale(this.liftOpen.x, 1);

    if (this.glare.y < -25) {
      this.glare.setCrop(0, 44 - this.glare.y, 141, 243 - (44 - this.glare.y));
    } else if (this.glare.y < 360 - 243) {
      this.glare.setCrop(0, 0, 141, 243);
    } else {
      this.glare.setCrop(0, 0, 141, 243 - (this.glare.y - 117));
    }
  }
}
